module.exports = __webpack_public_path__ + "static/media/pros-5.3d741a03.jpg";